import type {
	SensorDevice,
	SensorDeviceDTO,
	SensorMaintenanceResume,
	SensorMaintenanceResumeDTO,
	SensorMaintenanceState,
} from '../types/sensorMaintenanceLens.types';
import { parseThroughput } from '../utils/throughput';

function isMissingValue(value: string | null | undefined): boolean {
	if (value == null) return true;
	const normalized = value.trim().toUpperCase();
	return normalized === '' || normalized === 'NA' || normalized === 'N/A';
}

function resolveDeviceStatus(dto: SensorDeviceDTO): SensorMaintenanceState {
	if (parseThroughput(dto?.sensorData?.throughput) == null || isMissingValue(dto?.lastDataReceived)) {
		return 'withoutData';
	}
	if (!dto?.reportingOnTime) return 'inactive';
	return 'active';
}

export function mapSensorMaintenanceResume(dto: SensorMaintenanceResumeDTO): SensorMaintenanceResume {
	return {
		totalNumberOfDevices: dto?.totalNumberOfDevices ?? 0,
		systemThroughput: dto?.systemThroughput ?? '',
		active: dto?.reportingOnTime ?? 0,
		inactive: dto?.lateReporting ?? 0,
		withoutData: dto?.withoutData ?? 0,
	};
}

export function mapSensorDevice(dto: SensorDeviceDTO): SensorDevice {
	const sensorData = dto?.sensorData;
	return {
		deviceId: dto?.deviceId ?? '',
		latitude: Number.parseFloat(dto?.latitude ?? ''),
		longitude: Number.parseFloat(dto?.longitude ?? ''),
		deviceType: dto?.deviceType ?? '',
		reportingOnTime: dto?.reportingOnTime ?? false,
		status: resolveDeviceStatus(dto),
		lastDataReceived: dto?.lastDataReceived ?? '',
		rtuModel: sensorData?.rtuModel ?? '',
		sensorType: sensorData?.sensorType ?? '',
		throughput: sensorData?.throughput ?? null,
		lastReported: sensorData?.lastReported ?? '',
		lastServiced: sensorData?.lastServiced ?? '',
		sensorValues: sensorData?.sensorValues ?? [],
		sensorCapacityValues: dto?.sensorCapacityValues ?? [],
		imageBase64: dto?.imageBase64 ?? sensorData?.imageBase64 ?? '',
	};
}

export function mapSensorDevices(dtos: SensorDeviceDTO[]): SensorDevice[] {
	return (dtos ?? []).map(mapSensorDevice);
}
